import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import LeagueListVertical from "./leagueListVertical";
import LeagueMatch from './leagueMatch';
import "../../assets/css/scss/section/_league.scss"
import { isMobileOnly } from 'react-device-detect';
import Slider from 'react-slick';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//     faChevronCircleRight,
//     faChevronCircleLeft,
// } from "@fortawesome/free-solid-svg-icons";

interface ILeagueData {
    leagueList: string[]
}

const settings = {
    dots: false,
    infinite: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <FontAwesomeIcon icon={faChevronCircleRight} />,
    // prevArrow: <FontAwesomeIcon icon={faChevronCircleLeft} />,
    arrows: false,
    autoplay: true
};

export default function League(props: ILeagueData) {
    return (
        <Fragment>
            {/* <!-- league section --> */}
            <section className="leaugue-section">
                <Container>
                    <Row className={"justify-content-between align-items-center" + (props?.leagueList?.length < 4 ? " mb-2 mb-md-4" : "")}>
                        <Col md={9} lg={10} xl={9} className="order-md-last mb-3 mb-md-0">
                            {!isMobileOnly ?
                                <Row className="justify-content-between">
                                    <Col sm={6} xl={5}>
                                        <LeagueMatch />
                                    </Col>
                                    <Col sm={6} xl={{ span: 5, offset: 1 }}>
                                        <LeagueMatch />
                                    </Col>
                                </Row> :
                                <Slider {...settings}>
                                    <LeagueMatch />
                                    <LeagueMatch />
                                </Slider>
                            }
                        </Col>
                        <Col md={3} lg={2}>
                            <LeagueListVertical list={props?.leagueList} />
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* <!-- league section --> */}
        </Fragment>
    )
}
